import React from 'react';

/**
 * Editorial empty state — wine panel, icon, title, copy, and action slot.
 */
export default function StorefrontEmptyState({
  icon = null,
  title,
  text,
  children = null,
  className = '',
}) {
  return (
    <div className={`storefront-empty ${className}`.trim()} role="status">
      {icon ? (
        <div className="storefront-empty__icon" aria-hidden>
          {icon}
        </div>
      ) : null}
      {title ? <h2 className="storefront-empty__title">{title}</h2> : null}
      {text ? <p className="storefront-empty__text">{text}</p> : null}
      {children ? <div className="storefront-empty__actions">{children}</div> : null}
    </div>
  );
}
